module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Shield-thunder-2695d702ae51513239036a8cbefd18aa.svg";